import { render, staticRenderFns } from "./RicercaAnagraficaPaziente.vue?vue&type=template&id=555e36c8"
import script from "./RicercaAnagraficaPaziente.vue?vue&type=script&lang=js"
export * from "./RicercaAnagraficaPaziente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports